const team = [
  {
    name: 'Juziel Indriago',
    description: {
      en: 'CEO',
      es: 'Director<br/>General'
    },
    caracteristica: [
      {
        en: 'The mastermind of the entire company',
        es: 'La mente maestra de toda la empresa'
      },
      {
        en: 'Entrepreneur by nature',
        es: 'Emprendedor por naturaleza '
      },
      {
        en: 'Doesn\'t know how to say "No" when is facing a new challenge',
        es: 'No sabe decir “No” cuando se enfrenta a un nuevo reto'
      },
      {
        en: 'It\'s just a peace and love guy',
        es: 'Es solo paz y amor'
      }]
  },
  {
    name: 'Jahiezer Indriago',
    description: {
      en: 'Software<br/>developer',
      es: 'Desarrollador'
    },
    caracteristica: [
      {
        en: 'Front-end<br/>developer',
        es: 'Desarrollador<br/>Front-end'
      },
      {
        en: 'Expert in Vue.js and Drupal ',
        es: 'Experto en Vue.js y Drupal'
      },
      {
        en: 'The cool guy of the dreads',
        es: 'El tipo cool de los dreads'
      },
      {
        en: 'Give him a chocolate cake and he is the happiest developer of all',
        es: 'Regálale una torta de chocolate y es el programador más feliz'
      }]
  },
  {
    name: 'Jose Carrero',
    description: {
      en: 'Software<br/>developer',
      es: 'Desarrollador'
    },
    caracteristica: [
      {
        en: 'Full-stack<br/>developer',
        es: 'Desarrollador<br/>full-stack'
      },
      {
        en: 'Server administrator',
        es: 'Administrador de servidores '
      },
      {
        en: 'Dedicated Distracted',
        es: 'Distraído empedernido'
      },
      {
        en: 'His favorite word is "compile", in all its aspects',
        es: 'Su palabra favorita es “compilar”, en todas sus conjugaciones'
      }]
  },
  {
    name: 'Daniela Ruiz',
    description: {
      en: 'Software<br/>developer',
      es: 'Desarrolladora'
    },
    caracteristica: [
      {
        en: 'Back-end<br/>developer',
        es: 'Desarrolladora<br/>back-end'
      },
      {
        en: 'Responsible for the design and implementation of services for applications',
        es: 'Encargada del diseño e implementación de servicios para aplicaciones'
      },
      {
        en: 'Her concentration level is supreme. She still doesn’t give us the secret',
        es: 'Su nivel de concentración es suprema. Todavía no nos da el secreto'
      },
      {
        en: 'Calm voice and enigmatic attitude',
        es: 'De voz calmada y actitud pasiva'
      }]
  },
  {
    name: 'Jose Carrero',
    description: {
      en: 'Developer',
      es: 'Desarrollador'
    },
    caracteristica: [
      {
        en: 'Desarrollador full-stack',
        es: 'Desarrollador full-stack'
      },
      {
        en: 'Administrador de servidores  ',
        es: 'Administrador de servidores '
      },
      {
        en: 'Distraído empedernido',
        es: 'Distraído empedernido'
      },
      {
        en: 'Su palabra favorita es “compilar”, en todas sus conjugaciones',
        es: 'Su palabra favorita es “compilar”, en todas sus conjugaciones'
      }]
  },
  {
    name: 'Kora',
    description: {
      en: 'Chief Fluff<br/>Officer',
      es: 'Directora de Adorabilidad'
    },
    caracteristica: [
      {
        en: 'Expert on <br/>anti-stress techniques',
        es: 'Experta en técnicas  antiestrés'
      },
      {
        en: 'The most beloved thing in the office',
        es: 'Lo más consentido de la oficina'
      },
      {
        en: 'The sweetest bue eyes your ever meet',
        es: 'Los ojitos azules más dulces del mundo'
      },
      {
        en: 'Ice cubes and banana lover',
        es: 'Amante de los hielos y el cambur'
      }]
  },
  {
    name: 'Andreina Carrasco',
    description: {
      en: 'Social communicator',
      es: 'Comunicadora Social'
    },
    caracteristica: [
      {
        en: 'Project manager in digital projects',
        es: 'Project manager en diversos proyectos digitales'
      },
      {
        en: 'Customer service analyst',
        es: 'Analista de atención al cliente'
      },
      {
        en: 'Content redactor. Yes, even of everything that you just read',
        es: 'Redactora de contenidos. Sí, incluso de todo lo que acabas de leer'
      },
      {
        en: 'The girl who laughs alone',
        es: 'La que se ríe sola'
      }]
  },
  {
    name: 'Raquel Pereira',
    description: {
      en: 'Business Administrator',
      es: 'Administradora'
    },
    caracteristica: [
      {
        en: 'Business planning specialist',
        es: 'Especialista en planificación empresarial'
      },
      {
        en: 'She have the great ability to predict financial events',
        es: 'Con una gran habilidad para predecir eventos económicos y financieros'
      },
      {
        en: 'The accounts girl',
        es: 'La chica de las cuentas '
      },
      {
        en: 'The person in charge of the payments. Thanks Raquel, we all love you!',
        es: 'La encargada de los pagos. ¡Gracias Raquel, te queremos!'
      }]
  },
  {
    name: 'Vladimir Marcano',
    description: {
      en: 'Graphic<br/>Designer',
      es: 'Diseñador<br/>Gráfico'
    },
    caracteristica: [
      {
        en: 'Fan of minimalism',
        es: 'Aficionado al minimalismo'
      },
      {
        en: 'Creative designer of the current web design of Apök',
        es: 'Creador del actual diseño web de Apok'
      },
      {
        en: 'The coffee taster in the office',
        es: 'El catador de café de la oficina'
      },
      {
        en: 'Make Wood Lettering',
        es: 'Hace "Lettering" en madera'
      }]
  }
]
export default team



// WEBPACK FOOTER //
// ./src/config/team.js